module.exports = __webpack_public_path__ + "img/img5-bg.c48c438c.png";